export default __webpack_public_path__ + "static/media/peas.8031a92f.jpg";